import { useSession } from '../session/context';
import './RestoreBanner.css';

/** Relative "x ago" label for the autosave timestamp. */
function timeAgo(ms: number): string {
  const secs = Math.max(0, Math.round((Date.now() - ms) / 1000));
  if (secs < 60) return 'just now';
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.round(mins / 60);
  return hours < 24 ? `${hours} h ago` : `${Math.round(hours / 24)} d ago`;
}

/**
 * Restore prompt (SP5, cue-forge-9ww.1). When a locally-autosaved session is
 * found on mount and nothing is loaded yet, offer to restore it. The saved doc
 * lives only in this browser's IndexedDB — it was never uploaded.
 */
export function RestoreBanner() {
  const { restorable, loaded, restore, discardRestore } = useSession();
  if (!restorable || loaded) return null;

  const { filename, doc } = restorable.loaded;
  return (
    <div className="cf-restore" role="region" aria-label="Restore session">
      <p className="cf-restore__text">
        Restore your last session — <strong>{filename}</strong> ({doc.cues.length} cues, saved{' '}
        {timeAgo(restorable.savedAt)})?
      </p>
      <div className="cf-restore__actions">
        <button type="button" className="cf-btn" onClick={restore}>
          Restore
        </button>
        <button type="button" className="cf-btn" onClick={discardRestore}>
          Discard
        </button>
      </div>
    </div>
  );
}
